import { FC, lazy, Suspense } from "react";
import MainNav2 from "./MainNav2";
import MainNav1 from "./MainNav1";
import SkeletonDynamic from "components/Skeleton/Skeleton";
const MainNav2Logged = lazy(() => import("components/Header/MainNav2Logged"));

export interface HeaderProps {
  mainNavStyle?: "style1" | "style2" | "style2Logedin";
  isTopOfPage?: boolean;
}

const Header: FC<HeaderProps> = ({ mainNavStyle = "style1", isTopOfPage }) => {
  const renderMainNav = () => {
    switch (mainNavStyle) {
      case "style1":
        return <MainNav1 />;
      case "style2":
        return <MainNav2 />;
      case "style2Logedin":
        return <Suspense fallback={<SkeletonDynamic type="logo" />}>
          <MainNav2Logged />
          </Suspense>

      default:
        return <MainNav1 />;
    }
  };

  return (
    <header className="nc-Header sticky top-0 w-full left-0 right-0 z-40 transition-all">
      <div
        className={`bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-b dark:border-neutral-700 ${isTopOfPage ? "!border-transparent" : ""}`}
      >
        {renderMainNav()}
      </div>
    </header>
  );
};

export default Header;
